import React from 'react';
import {Link} from 'react-router-dom';
import API from '../../configAPI';
import PulseLoader from 'react-spinners/PulseLoader';
import CONFIG from '../../config';
import Moment from 'react-moment';
import 'moment-timezone';
class PostDetails extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            video : {
            },
            videos: [],
            loading: true
        }
    }
    componentDidMount(){
        this.getPost();
    }
    componentDidUpdate(prevProps){
        if(this.props.match.params.video !== prevProps.match.params.video){
            this.getPost();
        }
    }
    getPost = () =>{
        this.setState({
            loading: true
        });
        API.PRODUCTS(`video/${this.props.match.params.video}`)
        .then(resp =>{
            this.setState({
                video: resp.data.video,
                videos: resp.data.videos,
                loading: false
            });
        })
        .catch(err =>{
            console.log(err);
        });
    }
    render(){
        return (
            <div className="container-fluid mt-3 mb-3">
                <div className="col-12">
                    <PulseLoader
                        css={CONFIG.spinner_css}
                        size={CONFIG.spinner_size}
                        margin={CONFIG.spinner_margin}
                        color={CONFIG.spinner_color}
                        loading={this.state.loading}
                    />
                    <div className="row">
                        <section className="col xs-12 col-md-9">
                            
                            <br></br>
                            <p></p>

                            <iframe  width="100%" height="500vw" src={`https://www.youtube.com/embed/${this.state.video.url_video}`} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            <h3 className="mt-3">{this.state.video.titulo}</h3>
                            <p className="minitext"><strong>Publicado el <Moment format={'DD/MM/YYYY'}>{this.state.video.created_at}</Moment></strong></p>
                            <div dangerouslySetInnerHTML={{__html: this.state.video.info}}>
                                
                            </div>
                            
                        </section>

                        <div className="col-md-3">
                            <div className="col-12 mb-3"><h5>Videos que podrían interesarle</h5></div>
                            <section className="col-12 mb-4">
                                {this.state.videos.map((video,index) =>(
                                    <section key={index}>
                                        <div className="fila relativo">
                                            <Link to={`/video/${video.slug}`}> 
                                                { <img src={`https://panel.construproductos.com/images/products/${video.url_img}`} className="img-fluid" alt="{vid.titulo}"/> 
                                                /*<img src={`http://adminarq.expodeco.pe/images/products/${video.url_img}`} className="img-fluid" alt="{vid.titulo}"/> */}
                                                
                                                <div className="noticialink d-flex align-items-center p-2">
                                                    <div className="fila">
                                                    <section className="col-12 text-center">
                                                        <h1 className="noticiatitulo"><i class="far fa-play-circle"> ver video</i></h1>
                                                    </section>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                        <div className="mt-3">
                                            <h6><strong>{video.titulo}</strong></h6>
                                            <p className="minitext">Publicado el <Moment format={'DD/MM/YYYY'}>{video.created_at}</Moment></p>
                                           
                                        </div>
                                    </section>
                                ))}
                            
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default PostDetails;